<template>
  <el-container class="h-full flex flex-row page-container">
    <el-card class="doctor">
      <div class="flex flex-col doctor-list">
        <span class="label">医生列表</span>
        <!--    医生列表 start    -->
        <div v-loading="doctorListLoading" class="list flex flex-col">
          <doctor-item
            v-for="(doctor,index) in doctorList"
            :key="index"
            :name="doctor.name"
            :code="doctor.code"
            :description="doctor.content"
            class="doctor-item"
          />
        </div>
        <!--    医生列表 end    -->
        <!--    挂号 start    -->
        <el-dialog title="患者信息" :visible.sync="enrollVisible">
          <el-form
            ref="enrollForm"
            :model="enrollForm"
            :rules="enrollFormRules"
            label-width="80px"
            size="small"
          >
            <ik-form-data-popup
              v-model="enrollForm.phone"
              code="phone"
              name="联系电话"
              url="clinic/treatment/patient/patient/find/findPagination"
              :filed-list="[
                { code: 'name', name: '名称' },
                { code: 'contactPhone', name: '电话' },
                { code: 'idcardCode', name: '身份证号' }
              ]"
              search-key="contactPhone"
              :searcher="{'storeCode': storeCode}"
              :required="true"
              @onPopupClick="selectPatient"
            />
            <el-form-item label="患者姓名" prop="name">
              <el-input v-model="enrollForm.name" />
            </el-form-item>
            <el-form-item label="就诊卡号" prop="cardCode">
              <el-input v-model="enrollForm.cardCode" />
            </el-form-item>
            <el-form-item label="身份证号" prop="idcardCode">
              <el-input v-model="enrollForm.idcardCode" />
            </el-form-item>
            <el-form-item label="性别" prop="sexSign">
              <el-select v-model="enrollForm.sexSign">
                <el-option label="男" value="1" />
                <el-option label="女" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="出生年月" prop="birthDate">
              <el-date-picker v-model="enrollForm.birthDate" />
            </el-form-item>
            <el-form-item label="联系地址" prop="contactAddress">
              <el-input v-model="enrollForm.contactAddress" type="textarea" />
            </el-form-item>
            <el-form-item label="血型" prop="bloodTypeSign">
              <el-select v-model="enrollForm.bloodTypeSign">
                <el-option label="A" value="1" />
                <el-option label="B" value="2" />
                <el-option label="AB" value="3" />
                <el-option label="O" value="4" />
              </el-select>
            </el-form-item>
            <el-form-item label="收费标识" prop="feeSign">
              <el-select v-model="enrollForm.feeSign">
                <el-option label="收费" value="1" />
                <el-option label="不收费" value="0" />
              </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="enrollVisible = false">取消</el-button>
            <el-button
              v-loading="enrollBtnLoading"
              type="primary"
              @click="submitEnrollForm"
            >确定
            </el-button>
          </template>
        </el-dialog>
        <!--    挂号 end    -->
      </div>
    </el-card>
    <!--  就诊记录 start  -->
    <div class="enroll flex flex-col">
      <!--      <el-card class="search-form">-->
      <!--        <search-form @command="handleSearchFormCommand" />-->
      <!--      </el-card>-->
      <el-card class="current-user">
        <div class="patient-con h-full flex flex-col">
          <!--          <span class="title">当前用户</span>-->
          <model-header label="当前用户">
            <template #options>
              <!--              <el-button-->
              <!--                type="primary"-->
              <!--                size="small"-->
              <!--                @click="getPatientList"-->
              <!--              >查询</el-button>-->
              <el-button
                v-show="activeDiagRecord.diagRecord.stateSign==='3'"
                size="small"
                type="primary"
                @click="handleSearchFormCommand({command:'pay'})"
              >
                支付
              </el-button>
              <el-button
                v-show="activeDiagRecord.diagRecord.stateSign==='4'"
                size="small"
                type="primary"
                @click="handleSearchFormCommand({command:'dispatch'})"
              >发药</el-button>
              <!--              <el-button-->
              <!--                size="small"-->
              <!--                @click="resetPatientList"-->
              <!--              >重置</el-button>-->
            </template>
          </model-header>
          <patient-table ref="patient_table" />
        </div>
      </el-card>
    </div>
    <!--  就诊记录 end  -->
    <!--  支付弹窗 start  -->
    <el-dialog width="479px" :visible.sync="payVisible" title="支付结算">
      <pay />
    </el-dialog>
    <!--  支付弹窗 end  -->
    <!--  二维码 start  -->
    <el-dialog
      width="479px"
      :destroy-on-close="true"
      :show-close="false"
      :modal="false"
      custom-class="qrcode-con"
      :visible.sync="qrcodeVisible"
    >

      <div class="flex flex-col align-center">
        <div class="flex flex-row align-center pay-header">
          <img
            v-if="payWay==='aliPay'"
            src="@/assets/list/aliPay.png"
            alt=""
            class="icon-img"
          >
          <img
            v-if="payWay==='wechat'"
            src="@/assets/list/wechat.png"
            alt=""
            class="icon-img"
          >
          <span class="tip">请使用{{ payWay|PAY_WAY }}扫码支付</span>
        </div>
        <div ref="qrcode" />
      </div>
    </el-dialog>
    <!--  二维码 end  -->
    <!--  发药 start  -->
    <el-dialog title="发药" :visible.sync="dispatchVisible">
      <dispatch-med />
    </el-dialog>
    <!--  发药 end  -->
  </el-container>
</template>
<script>
import DoctorItem from "@/views/business/page/treatment/enroll/copm/DoctorItem.vue"
import PatientTable from "@/views/business/page/treatment/enroll/copm/PatientTable.vue"
import { findAll, getByCode } from "@/api/ik/data/dataApi"
import { postData } from "@/api/user/authApi"
import IkFormDataPopup from "@/components/ik/form/input/IkFormDataPopup/index.vue"
import dayjs from "dayjs"
import DispatchMed from "@/views/business/page/treatment/treatment/treatment/DispatchMed.vue"
import Pay from "@/views/business/page/treatment/treatment/treatment/Pay.vue"
import QRCode from "qrcodejs2"
import ModelHeader from "@/components/utils/ModelHeader.vue"

export default {
  name: "Enroll",
  components: { ModelHeader, Pay, DispatchMed, IkFormDataPopup, PatientTable, DoctorItem },
  filters: {
    /**
     * 支付方式
     * @param payWay
     * @returns {string}
     * @constructor
     */
    PAY_WAY(payWay) {
      switch (payWay) {
        case "wechat":
          return "微信"
        case "aliPay":
          return "支付宝"
      }
    }
  },
  data() {
    return {
      // 医生列表
      doctorListLoading: false,
      doctorList: [],
      // 挂号
      enrollVisible: false,
      enrollForm: {
        phone: "",
        name: "",
        cardCode: "",
        idcardCode: "",
        sexSign: "",
        birthDate: "",
        contactAddress: "",
        bloodTypeSign: "",
        feeSign: "1",
        storeUserCode: ""
      },
      enrollFormRules: {
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        sexSign: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "change" }
        ]
      },
      enrollBtnLoading: false,
      // 病人
      patientListLoading: false,
      patientList: [],
      searcher: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 5
      },
      // --- 就诊记录操作 ---
      activeDiagRecord: {
        preTreatmentRecord: null,
        diagRecord: {
          code: ""
        },
        treatmentRecord: {
          // 病历
          symContent: "", // 主诉关键字
          hisContent: "", // 既往史关键字
          familyContent: "", // 家族史关键字
          phyContent: "", // 体质关键字
          fdmContent: "", // 四诊关键字
          diagContent: "", // 诊断关键字
          chDiagContent: "", // 中医病关键字
          chYndromeContent: "", // 中医症关键字
          chTherapyContent: "", // 治法关键字
          highPressure: 0, // 血压高值
          lowPressure: 0, // 血压低值
          bloodSugar: 0, // 血糖
          temperature: 0, // 体温
          // 治疗
          medPositionCode: "", // 中成药药库编码
          medPositionName: "", // 中成药药库名称
          chmedPositionCode: "", // 饮片处方药库编码
          chmedPositionName: "", // 饮片处方药库名称
          servePositionCode: "", // 理疗安排药库编码
          doseNum: 0, // 总剂数
          dayDoseNum: 0, // 次/日
          dayFreq: 0, // 剂/日
          serveFeeSign: "01" // 加工方式
          // 01 代煎 11 制粒
          // 21 细粉打粉 22 粗粉打粉
          // 31 水丸制丸 32 蜜丸制丸 33 大蜜丸制丸 35 水蜜丸制丸
          // 41 制瓶装膏 42 制袋装膏 43 制块装膏},
        },
        chmedPrescription: {
          positionCode: "",
          positionName: "",
          serveFeeSign: "",
          doseNum: 0,
          dayDoseNum: 0,
          dayFreq: 0
        },
        chmedPrescriptionItemList: [],
        medPrescription: {
          positionCode: "",
          positionName: ""
        },
        medPrescriptionItemList: []
      }, // 当前用户
      payVisible: false, // 支付
      qrcodeVisible: false, // 二维码
      dispatchVisible: false, // 发药
      payWay: "aliPay", // 支付方式
      sendChmedList: [], // 饮片处方发药列表
      sendMedList: [] // 中成药处方发药列表
    }
  },
  provide() {
    return {
      pageData: this
    }
  },
  computed: {
    storeCode() {
      return this.$store.getters["user/getStoreCode"]
    }
  },
  created() {
    this.getDoctorList()
    this.getPatientList()
  },
  methods: {
    resetEnrollForm() {
      this.$nextTick(() => {
        if (this.$refs.enrollForm) {
          this.$refs.enrollForm.clearValidate() // 清除验证状态
          this.$refs.enrollForm.resetFields() // 重置字段值
        }
        this.enrollForm.phone = ''
      })
    },
    /**
     * 重置当前就诊记录
     */
    resetActiveDiagRecord() {

    },
    /**
     * 显示二维码
     * @param url
     */
    showQrCode(url) {
      this.payVisible = false
      this.qrcodeVisible = true
      this.$nextTick(() => {
        new QRCode(this.$refs.qrcode, {
          text: url,
          width: 274,
          height: 274,
          colorDark: "#000000",
          colorLight: "#ffffff"
        })
      })
    },
    /**
     * 刷新就诊记录
     */
    updateDiagRecord() {
      this.getPatientList()
    },
    /**
     * 刷新病人信息
     */
    updatePatientInfo() {
      this.$refs.patient_table.rowClick(this.activeDiagRecord.diagRecord)
    },
    /**
     * 查询表单指令处理
     * @param command
     */
    handleSearchFormCommand(command) {
      switch (command.command) {
        case "pay":
          this.payVisible = true
          break
        case "dispatch":
          this.dispatchMed()
          break
        default:
          break
      }
    },
    /**
     * 发药弹窗
     */
    dispatchMed() {
      if (this.activeDiagRecord.chmedPrescription.outOrdCode) {
        const chmedCode = this.activeDiagRecord["chmedPrescription"]["outOrdCode"]
        getByCode("clinic/inventory/change/outord", chmedCode)
          .then(res => {
            this.sendChmedList = res.data.body["outOrdItem"]
            this.activeDiagRecord.chmedPrescription = { ...this.activeDiagRecord.chmedPrescription, ...res.data }
          })
      }
      if (this.activeDiagRecord.medPrescription.outOrdCode) {
        const medCode = this.activeDiagRecord["medPrescription"]["outOrdCode"]
        getByCode("clinic/inventory/change/outord", medCode)
          .then(res => {
            this.sendMedList = res.data.body["outOrdItem"]
            this.activeDiagRecord.medPrescription = {
              ...this.activeDiagRecord.medPrescription,
              ...res.data
            }
          })
      }
      this.dispatchVisible = true
    },
    /**
     * 获取医生列表
     */
    getDoctorList() {
      const url = "base/user/user/storeuser"
      const pd = {
        storeCode: this.storeCode,
        doctorTypeSign: '1',
        stateSign: '2'
      }
      this.doctorListLoading = true
      findAll(url, pd)
        .then(res => {
          this.doctorList = res.data
        })
        .finally(() => {
          this.doctorListLoading = false
        })
    },
    /**
     * 获取病人列表
     */
    getPatientList() {
      const url = "clinic/treatment/treatment/diagrecord/find/findstoreactivediagrecord"
      const pd = {
        storeCode: this.storeCode
      }
      this.patientListLoading = true
      postData(url, pd)
        .then(res => {
          this.patientList = res.data
        })
        .finally(() => {
          this.patientListLoading = false
        })
    },
    /**
     * 重置查询条件
     */
    resetPatientList() {
      this.searcher = {}
      this.getPatientList()
    },
    /**
     * 挂号表单提交
     */
    submitEnrollForm() {
      this.$refs.enrollForm.validate((valid) => {
        if (valid) {
          const url = "clinic/treatment/treatment/diagrecord/do/storeenroll"
          const pd = {
            ...this.enrollForm,
            birthDate: dayjs(this.enrollForm.birthDate).format("YYYY-MM-DD")
          }
          this.enrollBtnLoading = true
          postData(url, pd)
            .then(res => {
              this.$message.success("挂号成功!")
              this.enrollVisible = false
              this.getPatientList()
              // 重置表单和验证状态
              this.resetEnrollForm()
            })
            .catch(error => {
              console.error("挂号失败:", error)
            })
            .finally(() => {
              this.enrollBtnLoading = false
            })
        } else {
        // 表单验证失败
          return false
        }
      })
    },
    /**
     * 选择病人
     * @param code
     * @param row
     */
    selectPatient(code, row) {
      this.enrollForm.name = row.name
      this.enrollForm.idcardCode = row.idcardCode
      this.enrollForm.sexSign = row.sexSign
      this.enrollForm.birthDate = row.birthDate
      this.enrollForm.cardCode = row.cardCode
      this.enrollForm.contactAddress = row.contactAddress
      this.enrollForm.bloodTypeSign = row.bloodTypeSign
      this.enrollForm.phone = row.contactPhone
    },
    handleEnrollDialogOpen() {
    // 每次打开对话框时重置表单和验证状态
      this.$nextTick(() => {
        if (this.$refs.enrollForm) {
          this.$refs.enrollForm.clearValidate()
        }
      })
    },

    /**
   * 处理对话框关闭事件
   */
    handleEnrollDialogClose() {
    // 关闭对话框时重置表单
      this.resetEnrollForm()
    }

  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 5px;
  height: calc(100vh - 84px); // 根据实际布局调整，减去顶部导航/标签栏高度
  overflow: hidden; // 禁止整体滚动
}

.doctor {
  width: 364px;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden; // 关键：防止内容撑开

  ::v-deep .el-card__body {
    height: 100%;
    overflow: hidden; // 防止el-card内部溢出
  }

  .doctor-list {
    height: 100%;
    overflow: hidden; // 关键
  }

  .list {
    flex: 1;
    overflow-y: auto; // 关键：医生列表独立滚动
    overflow-x: hidden;

    // 隐藏滚动条但保留滚动功能（可选）
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
.pay-header {
  margin-bottom: 73px;

  .icon-img {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }

  .tip {
    font-family: 思源黑体 CN PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 24px;
    line-height: 22px;
  }
}
::v-deep .qrcode-con {
  background-image: url("../../../../../assets/list/qrcode.png");
  background-repeat: no-repeat;
  height: 676px;
  border-radius: 30px 30px 0 0;
  padding-top: 105px;
}
.enroll {
  flex: 1;
  overflow: hidden; // 关键：防止撑开父容器
  display: flex;
  flex-direction: column;

  .current-user {
    flex: 1;
    overflow: hidden; // 关键

    ::v-deep .el-card__body {
      height: 100%;
      overflow: hidden;
    }

    .patient-con {
      height: 100%;
      overflow: hidden; // 关键
    }
  }
}

// 患者表格区域需要独立滚动
::v-deep .patient-table {
  flex: 1;
  overflow-y: auto; // 患者列表独立滚动
  overflow-x: hidden;
}
</style>
